'use client';
import { createContext, ReactNode, use } from 'react';

const ServerReferrerContext = createContext<{ referrer: string | undefined }>({
  referrer: undefined,
});

export const useReferrer = () => use(ServerReferrerContext);

export function ServerReferrerProvider({
  children,
  referrer,
}: {
  children: ReactNode;
  referrer: string;
}) {
  return (
    <ServerReferrerContext value={{ referrer: referrer }}>
      {children}
    </ServerReferrerContext>
  );
}
